(() => {
  const GIFT_REWARD = '5g';
  const GIFT_SOURCE = 'drawer';
  const KEEP_DRAWER_OPEN_KEY = 'isl_keep_cart_drawer_open';

  function keepDrawerOpenOnNextLoad() {
    try {
      sessionStorage.setItem(KEEP_DRAWER_OPEN_KEY, '1');
    } catch (_) {}
  }

  function isInsideDrawer(element) {
    return !!element?.closest('.cart-drawer__dialog, cart-drawer-component, .cart-items__wrapper');
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });

    if (!response.ok) {
      throw new Error('Impossible de récupérer le panier');
    }

    return response.json();
  }

  function getGiftItemsForSlot(cart, slot) {
    return (cart.items || []).filter((item) => {
      const props = item.properties || {};
      return (
        props._isl_gift_reward === GIFT_REWARD &&
        String(props._isl_gift_slot || '') === String(slot)
      );
    });
  }

  async function removeGiftItemsForSlot(slot) {
    const cart = await fetchCart();
    const giftItems = getGiftItemsForSlot(cart, slot);

    if (!giftItems.length) return true;

    const updates = {};
    giftItems.forEach((item) => {
      updates[item.key] = 0;
    });

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ updates }),
    });

    if (!response.ok) {
      throw new Error('Impossible de retirer le cadeau existant');
    }

    return true;
  }

  async function addGiftVariant(variantId, slot) {
    const payload = {
      items: [
        {
          id: Number(variantId),
          quantity: 1,
          properties: {
            _isl_gift_reward: GIFT_REWARD,
            _isl_gift_slot: String(slot),
            _isl_gift_source: GIFT_SOURCE,
            _isl_gift_threshold: '100€',
          },
        },
      ],
    };

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error('Impossible d’ajouter le cadeau au panier');
    }

    return response.json();
  }

  function updateSelectedText(dialog, selectedInput) {
    const selectedText = dialog.querySelector('[data-gift-selected-text]');
    const confirmButton = dialog.querySelector('[data-gift-confirm]');

    if (!selectedText || !confirmButton) return;

    if (selectedInput) {
      const title = selectedInput.dataset.giftTitle || '1 cadeau';
      selectedText.textContent = `Sélectionné : ${title}`;
      confirmButton.disabled = false;
    } else {
      selectedText.textContent = 'Sélectionné : 0 / 1';
      confirmButton.disabled = true;
    }
  }

  function closeDialog(dialog) {
    if (!dialog) return;

    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.remove();
    }
  }

  function buildDialog(programEl) {
    const template = programEl.querySelector('[data-gift-template]');
    if (!template) return null;

    const dialog = template.content.firstElementChild.cloneNode(true);
    document.body.appendChild(dialog);
    return dialog;
  }

  function setupDialog(dialog, slot, selectedVariantId) {
    if (!dialog) return;

    const inputs = dialog.querySelectorAll('[data-gift-choice]');
    const confirmButton = dialog.querySelector('[data-gift-confirm]');
    const closeButtons = dialog.querySelectorAll('[data-gift-close]');

    inputs.forEach((input) => {
      if (selectedVariantId && String(input.value) === String(selectedVariantId)) {
        input.checked = true;
      }

      input.addEventListener('change', () => {
        updateSelectedText(dialog, dialog.querySelector('[data-gift-choice]:checked'));
      });
    });

    updateSelectedText(dialog, dialog.querySelector('[data-gift-choice]:checked'));

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        closeDialog(dialog);
      });
    });

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDialog(dialog);
    });

    dialog.addEventListener('close', () => {
      dialog.remove();
    });

    if (confirmButton) {
      confirmButton.addEventListener('click', async () => {
        const selectedInput = dialog.querySelector('[data-gift-choice]:checked');
        if (!selectedInput) return;

        confirmButton.disabled = true;

        try {
          keepDrawerOpenOnNextLoad();
          await removeGiftItemsForSlot(slot);
          await addGiftVariant(selectedInput.value, slot);
          closeDialog(dialog);
          window.location.reload();
        } catch (error) {
          console.error('ISL gift error:', error);
          alert("Impossible d'ajouter le cadeau pour le moment.");
          confirmButton.disabled = false;
        }
      });
    }
  }

  function openGiftDialog(button) {
    const programEl = button.closest('[data-gift-program]');
    if (!programEl) return;

    const slot = button.dataset.giftSlot;
    const selectedVariantId = button.dataset.selectedVariantId || '';

    const dialog = buildDialog(programEl);
    if (!dialog) return;

    setupDialog(dialog, slot, selectedVariantId);

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', 'open');
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      const openButton = event.target.closest('[data-gift-open]');
      if (!openButton) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      openGiftDialog(openButton);
    },
    true
  );

  /**
   * IMPORTANT :
   * on marque "garder le panier ouvert" AVANT toutes les actions
   * de suppression / quantité dans le drawer.
   */

  document.addEventListener(
    'mousedown',
    (event) => {
      const target = event.target;
      if (!isInsideDrawer(target)) return;

      if (
        target.closest('.cart-items__remove') ||
        target.closest('.quantity-selector button') ||
        target.closest('[data-gift-open]')
      ) {
        keepDrawerOpenOnNextLoad();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!isInsideDrawer(target)) return;

      if (
        target.closest('.cart-items__remove') ||
        target.closest('.quantity-selector button') ||
        target.closest('[data-gift-open]')
      ) {
        keepDrawerOpenOnNextLoad();
      }
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      const target = event.target;
      if (!isInsideDrawer(target)) return;

      if (target.matches('.quantity-selector input')) {
        keepDrawerOpenOnNextLoad();
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!isInsideDrawer(form)) return;

      if (form.matches('#cart-form, form[action*="/cart"], form[action*="/cart/change"]')) {
        keepDrawerOpenOnNextLoad();
      }
    },
    true
  );
})();